import { usePreQuestions } from "@/components/features/items/edit/_shared/ui/components/main/questions/pre-question/hooks";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

export const useReservationBasePolicyPreQuestions = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { questions } = viewModel;

	return usePreQuestions({ questions, onSetViewModel });
};
